import { LayerGroup } from 'react-leaflet';
import { useRef, useEffect } from 'react';
import * as L from "leaflet";
import "leaflet.markercluster";
import { faMapMarker } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

import { renderToStaticMarkup } from 'react-dom/server';

const TowerIcon = L.divIcon({
  html: renderToStaticMarkup(<FontAwesomeIcon icon={faMapMarker} className="iconTower" />),
  iconAnchor: [9, 24],  // set to [1/2 width, full height];
  popupAnchor: [0, -14]
});

const TowerIconFiltered = L.divIcon({
  html: renderToStaticMarkup(<FontAwesomeIcon icon={faMapMarker} className="iconTower iconTowerFiltered iconShadow" />),
  iconAnchor: [9, 24],  // set to [1/2 width, full height];
  popupAnchor: [0, -14]
});


const MapLayers = ({ data }) => {
  const layerGroup = useRef(null);

  useEffect(() => {
    if (layerGroup.current) {
      const d = new L.GeoJSON(data, {
        onEachFeature: addPopup,
        pointToLayer: (feature, latlng) => {
          if (feature.properties.isFiltered) return L.marker(latlng, { icon: TowerIconFiltered });
          return L.marker(latlng, { icon: TowerIcon });
        }
      });

      const clusterGroup = L.markerClusterGroup({ maxClusterRadius: 20 });//.addLayer(d);
      clusterGroup.addLayer(d);
      layerGroup.current.clearLayers().addLayer(clusterGroup);
    }
  }, [data]);

  const addPopup = (feature, layer) => {
    const popupContent = `
      <h3 class="MuiTypography-root MuiTypography-subtitle1 customPopupTitle" componenet="h1"> ${feature.properties["Assest Nick Name"]}</h6>
      
      ${feature.properties["City"] ? `
      <span class="MuiTypography-root MuiTypography-body1 MuiCardHeader-subheader MuiTypography-gutterBottom">
        <h5 class="MuiTypography-root MuiTypography-caption customPopupSub2"> ${feature.properties["City"]}, ${feature.properties["State"]}</h2
      </span>
      ` : `<span>&nbsp;</span>`
      }

      <div class="MuiTypography-root MuiTypography-body1 customPopupText">Overall Tower Height: ${feature.properties['Overall Tower Height']}</div>
      <div class="MuiTypography-root MuiTypography-body1 customPopupText">Ground Space Available: ${feature.properties['Ground Space Available']}</div>
     `
    // <h5 class="MuiTypography-root MuiTypography-subtitle2 customPopupSub1">Tower Type: ${feature.properties["Tower Type"]}</h2>
    //  <div class="MuiTypography-root MuiTypography-body1 customPopupText">Available RAD1: ${feature.properties['Available RAD RAD 1(s)']}</div>
    //   <div class="MuiTypography-root MuiTypography-body1 MuiTypography-gutterBottom customPopupText">Available RAD2: ${feature.properties['Available RAD 2(s)']}</div>
    //   <div class="MuiTypography-root MuiTypography-body1 customPopupText">Zoned for Collocation: ${feature.properties['Zoned for Collocation']}</div>

    layer.bindPopup(popupContent);
  };


  return (
    <>
      <LayerGroup
        ref={layerGroup}/>
    </>
  );
}

export default MapLayers;
